import ProductFolderComponent from './ProductFolderComponent';
export default ProductFolderComponent;
